export default "__VITE_ASSET__ChcRS9Fj__"